import React, { useState, useEffect } from 'react';
import './TotalVisitsCounter.css';
import { getTotalVisits, incrementTotalVisits } from '../services/totalVisitsService';

const TotalVisitsCounter = () => {
  const [totalVisits, setTotalVisits] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeVisitsCounter = async () => {
      try {
        // First, try to increment the count (only for new unique visitors)
        const newCount = await incrementTotalVisits();
        setTotalVisits(newCount);
      } catch (error) {
        console.error('Error initializing visits counter:', error);
        // Fallback: just get the current count without incrementing
        try {
          const currentCount = await getTotalVisits();
          setTotalVisits(currentCount);
        } catch (fallbackError) {
          console.error('Fallback error:', fallbackError);
        }
      } finally {
        setLoading(false);
      }
    };

    initializeVisitsCounter();
  }, []);

  if (loading) {
    return (
      <div className="total-visits-counter loading">
        <div className="counter-icon">👀</div>
        <div className="counter-text">Loading...</div>
      </div>
    );
  }

  return (
    <div className="total-visits-counter">
      <div className="counter-icon">👀</div>
      <div className="counter-text">
        <span className="counter-number">{totalVisits.toLocaleString()}</span>
        <span className="counter-label">visits</span>
      </div>
    </div>
  );
};

export default TotalVisitsCounter;
